import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-player-rounds',
  templateUrl: './player-rounds.component.html',
  styleUrls: ['./player-rounds.component.scss']
})
export class PlayerRoundsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
